import { mapState } from "vuex";
import { Component, Vue } from "vue-property-decorator";
import { IState } from "@/store";
import { ICurrency } from "@/models/constants";

@Component({
  computed: {
    ...mapState({
      brandCurrencyId: (state: IState) => state.brand.currency_id
    })
  }
})
export default class BrandCurrencyId extends Vue {
  // getters
  public brandCurrencyId!: ICurrency["id"];
}
